<template>
    <main class="app">
        <div v-show="!edit">
            <div class="main-header">
                <h1>Empresas</h1>
            </div>

            <div v-show="isLoading">
                <div
                    id="div-with-loading"
                    class="vs-con-loading__container"
                ></div>
            </div>

            <div class="card entities" v-show="!isLoading">
                <!-- Filtros solo para movile -->
                <div class="hide-on-small">
                    <organization-filter
                        class="org-filters"
                        @update-filters="updateFilters"
                    ></organization-filter>
                </div>
                <!-- -->

                <table class="n-table main-table bordered">
                    <thead class="header">
                        <th @click="sortByBusinessName" class="selectable">
                            Empresa
                            <vs-icon
                                class="th-icon"
                                :icon="
                                    arrowDownBusinessName
                                        ? 'arrow_drop_down'
                                        : 'arrow_drop_up'
                                "
                            />
                        </th>
                        <th>Establecimientos</th>
                        <th>Usuarios</th>
                        <th @click="sortByCreation" class="selectable">
                            Fecha de Creación
                            <vs-icon
                                class="th-icon"
                                :icon="
                                    arrowDownCreatedAt
                                        ? 'arrow_drop_down'
                                        : 'arrow_drop_up'
                                "
                            />
                        </th>

                        <th @click="sortByState" class="selectable">
                            Estado
                            <vs-icon
                                class="th-icon"
                                :icon="
                                    arrowDownSortByState
                                        ? 'arrow_drop_down'
                                        : 'arrow_drop_up'
                                "
                            />
                        </th>

                        <th class="filters ">
                                <organization-filter
                                    class="org-filters"
                                    @update-filters="updateFilters"
                                ></organization-filter>
                        </th>
                    </thead>

                    <tbody>
                        <tr v-for="org in organizations" :key="org.id">
                            <td class="business-name" data-label="Empresa">{{ org.businessName }}</td>
                            <td data-label="Establecimientos">
                                {{ org.establishments.length }}
                            </td>
                            <td data-label="Usuarios">
                                {{ org.users.length }}
                            </td>
                            <td data-label="Fecha de Creación">
                                {{ org.createdAt }}
                            </td>
                            <td class="org-status" data-label="Estado">
                                {{
                                    $t(
                                        `organization.registrationState.${org.registrationState}`
                                    )
                                }}
                            </td>
                            <!--{{ org. }} ESTADO: habilitado, pendiente etc-->
                            <td class="actions">
                                <button  @click="editButton(org)">
                                    <vs-icon
                                        icon="add_circle_outline"
                                    ></vs-icon>
                                    <span>Ver detalle</span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <OrganizationSettingsBackend
            v-if="edit"
            @reload="getOrganizations()"
            :organization="organization"
            @updated-edit="editButton"
        ></OrganizationSettingsBackend>

        <WePagination
            v-if="!edit && totalPages > 1 && !isLoading"
            :total="totalPages"
            v-model="pagination"
        />
    </main>
</template>

<script>
import EntityAdminTab from "./EntityAdminTab";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";
import { mapMutations, mapState } from "vuex";
import Vue from "vue";
import OrganizationSettingsBackend from "../OrganizationSettingsBackend";
import OrganizationFilter from "./OrganizationFilter.vue";
import WePagination from "../../lib/WebExperto/components/WePagination.vue";

axios.defaults.headers.common["referer-id"] =
    new Date().toLocaleString().replace(/[^\d]/g, "") +
    parseInt(Math.random() * 100000);

const listOrganizations = gql`
    query listOrganizations(
        $currentUserToken: String!
        $page: Int
        $perPage: Int
        $sort: SortFilter
        $stateFilter: String
        $roleFilter: String
    ) {
        listOrganizations(
            currentUserToken: $currentUserToken
            page: $page
            perPage: $perPage
            sort: $sort
            stateFilter: $stateFilter
            roleFilter: $roleFilter
        ) {
            organizations {
                adminId
                businessName
                city
                comments
                commercialAddress
                country
                cuit
                possibleStates
                registrationState
                email
                createdAt
                establishments {
                    active
                    activity
                    city
                    cuig
                    id
                    marketRole
                    name
                    number
                    renspa
                    ruca
                    state
                    users {
                        active
                        canBuy
                        canSell
                        createdAt
                        cuil
                        currentTime
                        dni
                        email
                        establishmentRole
                        firstname
                        id
                        lastname
                        offerRole
                        organizationId
                        passport
                        phone
                        userCanWrite
                    }
                    zipcode
                }
                id
                incomeTaxSituation
                ivaSituation
                logo
                ruca
                slaughterQuantityPerMonth
                productionMothers
                mainActivity
                phone
                state
                users {
                    active
                    canBuy
                    canSell
                    createdAt
                    cuil
                    currentTime
                    dni
                    email
                    establishmentRole
                    firstname
                    id
                    lastname
                    userCanWrite
                    offerRole
                    organizationId
                    passport
                    phone
                }
                zipcode
            }
            totalPages
        }
    }
`;

export default {
    name: "admin-organizations",
    data() {
        return {
            organizationSelectedState: "all",
            organizationSelectedFilterType: "all",
            isLoading: true,
            edit: false,
            filters: {},
            organizations: [],
            organization: {},
            totalPages: "",
            pagination: 1,
            sort: {
                sortBy: "created_at",
                desc: true,
            },
        };
    },
    components: {
        EntityAdminTab,
        OrganizationSettingsBackend,
        OrganizationFilter,
        WePagination,
    },
    computed: {
        ...mapState({
            currentUser: (state) => state.User.currentUser,
        }),
        arrowDownBusinessName() {
            return this.sort.sortBy === "business_name" && this.sort.desc;
        },
        arrowDownCreatedAt() {
            return this.sort.sortBy === "created_at" && this.sort.desc;
        },
        arrowDownSortByState() {
            return this.sort.sortBy === "registration_state" && this.sort.desc;
        },
    },
    beforeMount() {
        this.getOrganizations();
    },
    mounted() {
        this.$vs.loading({
            container: "#div-with-loading",
            scale: 3,
            type: "border",
            color: "#025c98",
            background: "#e8ebed",
        });
    },

    watch: {
        isLoading() {
            if (this.isLoading) {
                this.$vs.loading({
                    container: "#div-with-loading",
                    scale: 3,
                    type: "border",
                    color: "#025c98",
                    background: "#e8ebed",
                });
            } else {
                this.$vs.loading.close("#div-with-loading > .con-vs-loading");
            }
        },
        filters() {
            this.organizationSelectedState = this.filters.organizationSelectedState;
            this.organizationSelectedFilterType = this.filters.type
        },
        currentUser() {},
        pagination() {
            this.isLoading = true;
            this.getOrganizations();
        },
    },
    methods: {
        updateFilters(event) {
            this.organizationSelectedState = event.filter.state;
            this.organizationSelectedFilterType = event.filter.type
            this.sort = event.sort;

            this.pagination = 1;
            this.getOrganizations();
        },
        sortByBusinessName() {
            if (this.isLoading) {
                return;
            }

            this.pagination = 1;

            let desc = false;
            if (this.sort.sortBy === "business_name") {
                desc = !this.sort.desc;
            }
            this.sort = {
                sortBy: "business_name",
                desc,
            };
            this.getOrganizations();
        },
        sortByState() {
            if (this.isLoading) {
                return;
            }

            this.pagination = 1;

            let desc = false;
            if (this.sort.sortBy === "registration_state") {
                desc = !this.sort.desc;
            }
            this.sort = {
                sortBy: "registration_state",
                desc,
            };
            this.getOrganizations();
        },
        sortByCreation() {
            if (this.isLoading) {
                return;
            }

            this.pagination = 1;

            let desc = false;
            if (this.sort.sortBy === "created_at") {
                desc = !this.sort.desc;
            }
            this.sort = {
                sortBy: "created_at",
                desc,
            };
            this.getOrganizations();
        },
        waitingResponse() {
            this.isLoading = true;
        },
        editButton(org) {
            this.organization = org;
            this.edit = !this.edit;
            this.getOrganizations();
        },
        getOrganizations() {
            this.isLoading = true;
            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(listOrganizations),
                        variables: {
                            currentUserToken: localStorage.getItem(
                                "USER_TOKEN"
                            ),
                            page: this.pagination ? this.pagination : 1,
                            perPage: 50,
                            sort: this.sort,
                            stateFilter: this.organizationSelectedState,
                            roleFilter: this.organizationSelectedFilterType
                        },
                    },
                })
                .then((res) => {
                    this.isLoading = false;
                    if (!res.data.errors) {
                        (this.organizations =
                            res.data.data.listOrganizations.organizations),
                            (this.totalPages =
                                res.data.data.listOrganizations.totalPages);
                        if (this.organization && this.organization.id) {
                            this.organization = this.organizations.find(
                                (org) => org.id == this.organization.id
                            );
                        }
                    } else {
                        console.log(res.data.errors);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>

<style scoped>
th {
    text-align: left;
    vertical-align: center;
    align-content: bottom;
}
.th-icon {
    transform: translateY(5px);
}
.selectable {
    transform: translateY(-4px);
}
.selectable:hover {
    cursor: pointer;
}
.org-filters {
    padding-right: 5px !important;
    margin: 0px !important;
}

.actions {
    text-align: center;
}
#div-with-loading {
    width: 300px;
    height: 300px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.hide-on-small {
    display: block;
    float: right;
}
.business-name {
    max-width: 120px;
}
.filters {
    max-width: 100px;
    text-align: center !important;
}
.filter-button {
    padding: 0px;
}

.btn {
    padding: 0px !important;
}

@media only screen and (min-width: 992px) {
    .hide-on-small {
        display: none;
    }
}

@media only screen and (max-width: 992px) {
   .business-name {
        max-width: none !important;
    }
}

@media only screen and (min-width: 1124px) {
    .org-status {
        max-width: 120px;
    }
}
</style>